export default "__VITE_ASSET__DaLIFVu2__"